import * as color from './PeriscopeHeader.module.scss';
import { getSonarObjectTypeSourceLabel } from '@sonar-software/sonar-ts-lib';
import { ORGANIZATION_TYPE_LABELS } from '@sonar-software/sonar-ts-constants';
import { PeriscopeClose } from './PeriscopeClose';
import { PeriscopeSourceLabel } from './PeriscopeSourceLabel';
import { PeriscopeTypeLabel } from './PeriscopeTypeLabel';
import React, { useMemo } from 'react';
const headerBackgroundColorMap = {
    [ORGANIZATION_TYPE_LABELS.PARDOT]: color.pardotBlue,
    [ORGANIZATION_TYPE_LABELS.SALESFORCE]: color.salesforceBlue,
    [ORGANIZATION_TYPE_LABELS.SONAR]: color.arovyBlue
};
export const PeriscopeHeader = ({ headerLabel, index, sonarObjectType, subType, url }) => {
    const headerColor = useMemo(() => headerBackgroundColorMap[getSonarObjectTypeSourceLabel(sonarObjectType)], [sonarObjectType]);
    return (React.createElement("div", { className: 'periscope-header-wrapper', style: { background: headerColor } },
        React.createElement(PeriscopeTypeLabel, { headerLabel: headerLabel, sonarObjectType: sonarObjectType, subType: subType }),
        React.createElement(PeriscopeSourceLabel, { sonarObjectType: sonarObjectType, url: url }),
        React.createElement(PeriscopeClose, { index: index })));
};
